import memoizeOne from 'memoize-one';
import { extensionFrame, layoutSectionWithSingleColumn, multiBodiedExtension, expandWithNestedExpand, tableWithNestedTable, listItemWithDecisionStage0, tableRowWithNestedTable, tableCellWithNestedTable, tableHeaderWithNestedTable, syncBlock, bodiedSyncBlock } from './nodes';
import { createSchema } from './create-schema';
var getDefaultSchemaConfig = function getDefaultSchemaConfig() {
  var defaultSchemaConfig = {
    nodes: ['doc', 'paragraph', 'text', 'bulletList', 'orderedList', 'listItem', 'heading', 'blockquote', 'codeBlock', 'panel', 'rule', 'image', 'caption', 'mention', 'media', 'mediaGroup', 'mediaSingle', 'mediaInline', 'confluenceUnsupportedBlock', 'confluenceUnsupportedInline', 'confluenceJiraIssue', 'expand', 'nestedExpand', 'extension', 'inlineExtension', 'bodiedExtension', 'hardBreak', 'emoji', 'table', 'tableCell', 'tableHeader', 'tableRow', 'decisionList', 'decisionItem', 'taskList', 'taskItem', 'blockTaskItem', 'unknownBlock', 'date', 'status', 'placeholder', 'layoutSection', 'layoutColumn', 'inlineCard', 'blockCard', 'embedCard', 'unsupportedBlock', 'unsupportedInline'],
    marks: ['link', 'em', 'strong', 'strike', 'subsup', 'underline', 'code', 'textColor', 'backgroundColor', 'confluenceInlineComment', 'breakout', 'alignment', 'indentation', 'annotation', 'dataConsumer', 'border', 'unsupportedMark', 'unsupportedNodeAttribute', 'typeAheadQuery',
    // https://product-fabric.atlassian.net/browse/ED-10214,
    'fragment']
  };
  return defaultSchemaConfig;
};
export var defaultSchemaConfig = getDefaultSchemaConfig();
export var getSchemaBasedOnStage = memoizeOne(function () {
  var stage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'final';
  var defaultSchemaConfig = getDefaultSchemaConfig();
  if (stage === 'stage0') {
    defaultSchemaConfig.customNodeSpecs = {
      layoutSection: layoutSectionWithSingleColumn,
      multiBodiedExtension: multiBodiedExtension,
      extensionFrame: extensionFrame,
      expand: expandWithNestedExpand,
      listItem: listItemWithDecisionStage0,
      table: tableWithNestedTable,
      tableRow: tableRowWithNestedTable,
      tableCell: tableCellWithNestedTable,
      tableHeader: tableHeaderWithNestedTable,
      syncBlock: syncBlock,
      bodiedSyncBlock: bodiedSyncBlock
    };
  }
  return createSchema(defaultSchemaConfig);
});
export var defaultSchema = getSchemaBasedOnStage();